import { render, staticRenderFns } from "./RecommendationItem.vue?vue&type=template&id=19cdbfc0&scoped=true&"
import script from "./RecommendationItem.vue?vue&type=script&setup=true&lang=js&"
export * from "./RecommendationItem.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./RecommendationItem.vue?vue&type=style&index=0&id=19cdbfc0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19cdbfc0",
  null
  
)

export default component.exports